import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";

type Role = "interviewer" | "candidate";

const APIURL =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://entntcareersapi.azurewebsites.net/api"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://testentntcareersapi-ebdzgyenhpdwbjfj.centralindia-01.azurewebsites.net/api"
      : "https://localhost:7154";

export function useInterviewSocket(
  interviewId: string | null,
  role: Role,
  onQuestion: (q: any) => void
) {
  const connectionRef = useRef<signalR.HubConnection | null>(null);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${APIURL}/ws/interview?role=${role}`,
        {
          withCredentials: true,
        }
      )
      .withAutomaticReconnect()
      .build();

    connectionRef.current = connection;

    connection.start()
      .then(() => {
        console.log("SignalR connected");
        connection.invoke("JoinInterview", { interviewId, role });
      })
      .catch(console.error);

    connection.on("QuestionPushed", (question: any) => {
      onQuestion(question);
    });

    return () => {
      connection.stop();
    };
  }, [interviewId, role]);

  return connectionRef;
}
